
/**
 * Formats a user's name from their email address.
 * @param email - Email address from the user in form of name.name@draexlmaier.com
 * @returns The formatted user name.
 */
export function formatUserNameFromEmail(email: string): string {
    if (!email) return '';

    const namePart = email.split('@')[0];
    const cleanName = namePart.split('_').pop() || '';

    return cleanName
        .split(/[._-]/)
        .filter(Boolean)
        .map(segment =>
        segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase()
        )
        .join(' ');
}
